// One block of the day: a heading, how many things are in it, and the rows.
//
// EVERY SECTION IS ALWAYS ON THE PAGE, and an empty one SAYS SO. A section that hid
// itself when it had nothing left the day looking incomplete rather than clear — with no
// משימות block on screen there is no way to tell "nothing is due today" from "that part
// did not render". So emptiness is a sentence here, never an absence, and the `empty`
// prop is required of every caller for exactly that reason.
//
// THE COUNT IS OF WHAT IS ON SCREEN, not of what the server sent. The both/mine filter
// runs in the page above this, so a section headed "3" while showing one row would be the
// filter quietly disagreeing with itself. At zero it is dropped altogether: the empty
// line already says it, and a "0" chip beside it says it twice.
export default function DaySection({ title, count, empty, children }) {
  return (
    <section className="day-section card">
      <div className="day-section-head">
        <h2>{title}</h2>
        {count > 0 && <span className="count">{count}</span>}
      </div>
      {count > 0 ? children : <p className="muted small-note day-none">{empty}</p>}
    </section>
  );
}

// The sub-heading inside a section — באיחור above להיום. Rendered by the caller only when
// the group holds something: a heading over nothing says there is something there.
export function DayGroup({ title, late, children }) {
  return (
    <div className="day-group">
      <div className={`day-group-title${late ? ' is-late' : ''}`}>{title}</div>
      {children}
    </div>
  );
}
